export const POST_CONFIRM_PASSWORD = 'POST_CONFIRM_PASSWORD';
export const POST_CONFIRM_PASSWORD_SUCCESS = 'POST_CONFIRM_PASSWORD_SUCCESS';
export const POST_CONFIRM_PASSWORD_FAILURE = 'POST_CONFIRM_PASSWORD_FAILURE';
